import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  IWizItemRenderer,
  WizButton,
  WizHgroup,
  WizImage,
  WizLabel,
  WizPopUp,
  WizVgroup,
} from '@wizeoo/akm-component-lib';
import { Observable, of } from 'rxjs';

import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { BaselineEngine, FIELD_KIND, FeiKeyDef, FreedataArgsVO, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

import { ViewData } from '../../../../model/view.data';
import { Model } from '../../../../model/model';
import { IWidget } from '../../../../manager/widgets/i-widget';
import { FeiVO } from '../../../../vo/workingdata/fei.vo';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { IForm } from '../../../../manager/widgets/i-form';
import { ConnectVO } from '../../../../vo/core/connect.vo';
import { AttachmentService, MediaReference } from "../../../../command/core/attachment/attachment.service";
import { PopUtils } from '../../../../framework/components/pop/pop-utils';
import { zoomPopParams } from '../../freedatas/renderers/zoom.pop';
import { FreedataValueVO } from '../../../../vo/core/freedatavalue.vo';


/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'smallformfield-renderer',
  templateUrl: './smallformfield.renderer.html',
})
export class SmallFormFieldRenderer implements AfterViewInit, IWizItemRenderer<WidgetConfigurationItemObj, FormFieldObj> {
  
  constructor(public elementRef: ElementRef, private _cdRef: ChangeDetectorRef) {}
  
  @ViewChild('argContainer') argContainer: WizHgroup; // groupe principal

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image du FDV
    @ViewChild('imgLbl', { read: WizLabel, static: false }) imgLbl: WizLabel;
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  @ViewChild('bt', { read: WizButton, static: false }) bt: WizButton; // fonction connect

  @ViewChild('linkGp', { read: WizHgroup, static: false }) linkGp: WizHgroup; // rendu hyperlink du FDV

  @ViewChild('freeGrp', { read: WizHgroup, static: false }) freeGrp: WizHgroup; // rendu html libre
  @ViewChild('ae') ae: AngularEditorComponent; // bt save
    
  @ViewChild('freeImgGrp', { read: WizHgroup, static: false }) freeImgGrp: WizHgroup; // groupe image libre
    @ViewChild('freeImg') freeImg: WizImage; // image libre
  
  @ViewChild('workflowGroup', { read: WizVgroup, static: false }) workflowGroup: WizVgroup; // rendu hyperlink du FDV


    /**
     * contexte. Attention, non disponible dans la vue Freedata
     */
    public get context(): WidgetConfigurationItemObj {
      return  this.data?.wcio; //  this.data?.context?.source;
    }

    public get injectClass(): string {
      let myclass: string = 'voidme';
      if(!!this.context?.sty) {
        myclass = this.context?.sty;
      }
      return myclass;
    }



  private rawValue: string = null; // valeur brute (en cours de traitement)
  public formatedValue: any = null; // la valeur formatée pour le rendu dans les composants 

    //##### les activateurs de ngIf ######

    uselbl = false; // rendu simple

    useimgGp = false;
    usemedia = false;
    
    uselinkGp = false; // pas de link par défaut...
    public linkUrl: string = ''; // cas d'un rendu link, label|url
    public linkLabel: string = ''; // cas d'un rendu link, label|url

    usebt = false; // fonction connect
    public cnx: ConnectVO = null; // fonction connect du bouton

    usefreeGrp = false; // gestion rendu libre
    
    usefreeImgGrp = false; // image libre
    public imgSrcObs: Observable<string> = null;
    public imgBlobid: string = null;

    usecolor = false; // champ de type color
    usecb = false; // champs booléen

    useworkflow = false; // rendu workflow
      public workImage: Observable<string> = of(null); // image liée
      public workImageBlob: string = null;
      public workIcon: string = null; // l'icone du statut si utilisée
      public workflowLabel: string = null; // le libellé du workflow
      public workFile:  MediaReference = null; // pièce jointe

    uselistGP = false; // champs liste de valeurs



  /** configuration de l'editeur html */
  public editorConfig:AngularEditorConfig = {
    width: '100%',
    height: '100%',
    editable: false,
    enableToolbar: false,
    showToolbar: false,
    spellcheck: false,
    //imageResizeSensitivity: 0
  }

  owner: null;
  
  private _data: FormFieldObj; // données sources
  @Input() public set data(ffo: FormFieldObj) {
    this._data = ffo;
    this.fkd = ffo.fkd;
    this.fei = ffo.fei;
    // this.widget = ffo.widget;
  }
  public get data(): FormFieldObj {
    return this._data;
  }

  /**
   * accesseur sur la configuration du champ
   */
  public get wcio(): WidgetConfigurationItemObj {
    return this.data?.wcio || null;
  }


  _entity: any = null;
  @Input()public set entity(value: any) {
    this._entity = value;
    // console.log('smallFFO entity', value);
  }
  public get entity(): any {
    return this._entity;
  }

  /**
   * accesseur sur la widgetLine
   */
  public  get widgetLine(): WidgetLine {
    if(this._entity) {
      return this._entity as WidgetLine;
    }
    return null;
  }

  public fei: FeiVO; // en vrai, c'est le fake
  
  // public widget: IWidget; // accesseur sur le widget
  public fkd: FeiKeyDef; // la définition de la clé. Nul dans le cas des champs libres

  public get widget(): IWidget {
    return this.data?.widget as IWidget;
  }

  public get model(): Model {
    return this.widget?.model;
  }


  /** rendu label custom ou label par défaut */
  public get alternateLabel(): string {
    let result: string = this.data?.label;
    return result;
  }

  /** affichage ou pas du libellé */
  public get showLabel() :boolean {
    // console.log('argRenderer showLabel', this._data.context?.showLabel);
    return this._data.wcio?.slbl;
  }


  /** présence d'une image, pour affichage de la poubelle */
  public hasImage(): boolean {
    return false;
    // const valueStr: string = !!this.data.arg ? this.data?.fdv?.argsObj[this.data.arg.code] : null;
    // return !!valueStr;
  }

  /** readonly sur les images, pas de poubelle */
  public get readOnly():boolean {
    return this.argContainer?.wizDisabled;
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.feed();
    }, 0);
  }

  ngOnDestroy(){ 
  }

  /**
   * alimentation initiale ou par injection de valeurs sur peuplement automatique
   * public car peut être appelé par le BlGridsterItem lors de la mise à jour de la configuration du champ
   */
  public feed(): void {
   
   // console.log('feed smallFF', this.fkd,this.wcio.cod, this.widgetLine);
   
    if (!this.fkd) { // rendu libre rien à alimenter
      if (this.wcio.cod === ViewData.FORM_HTML) {
        this.formatedValue = this.wcio.lbl;
        this.usefreeGrp = true;
        if(this.ae) {
          this.ae.config = this.editorConfig;
          this.ae.placeholder='';
          this.ae.showPlaceholder = false;
          this.ae.writeValue(this.formatedValue);
        }  
      } else if (this.wcio.cod === ViewData.FORM_ACTION) {
        this.formatedValue = this.wcio.lbl;
        this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(this.formatedValue);
        this.usebt = true; 
      } else  if (this.wcio.cod === ViewData.FORM_IMAGE) {
        this.formatedValue = this.wcio.lbl;
        if(!!this.formatedValue) {
          let firstMed: string = this.formatedValue.split(WizConstants.KEY_SEPARATOR)[0];
          // console.log('BINARY_MULTI FDV', firstMed);
          this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(firstMed);
          this.imgBlobid = firstMed;
        } else {
          this.imgSrcObs = of(null);
          this.imgBlobid = null;
        }
        this.usefreeImgGrp = true;
      };
    } else {
      const rawVal: string = BaselineEngine.getRawKeyOrValue(this.fei, this.widgetLine, this.fkd.fullCode); // les données sont calculées par le formWidget
      this.rawValue = rawVal; // mémorisation de la valeur en cours
      if (this.fkd.isKey) { // les key / filters
        this.uselbl = this.wcio.slbl;
        this.keyFormatter(this.fkd, rawVal);
      } else {
        this.valueFormatter(this.fkd, rawVal);
      }
    }

    setTimeout(() => {
      this._cdRef.markForCheck();
    }, 0);

  }

  /**
   * détermine le bon type pour un champ
   * @param fkd 
   * @param fdvfield 
   * @returns 
   */
  private realKind(fkd: FeiKeyDef, fdvfield: string): string {
    let finalDatakind: string = fkd.datakind;
    if(fkd.isChrono) {
      finalDatakind = this.model.chronocodeEngine.getChronoFieldByCode(fdvfield).datakind;
    } else if(fkd.isFreedata) {
      // recherche du type du args demande
      let arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fkd.code, fdvfield);
      if(arg) {
        // console.log('arg', arg);
        finalDatakind = arg.dataType;
      }
    } else { // mesure
      finalDatakind = fkd.measure.dataKind;
    }

    return finalDatakind;
  }

  private realRenderer(rendererKind: string,  rawValue: string): void {
    if (rendererKind === FIELD_KIND.BOOLEAN) {
      this.usecb = true;
    } else if (rendererKind === FIELD_KIND.COLOR) {
      this.usecolor = true;
    } else if (rendererKind === FIELD_KIND.ACTION) {     
      this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(rawValue);
      this.usebt = true;
    } else if (rendererKind === FIELD_KIND.WORKFLOW) {

      let settings: any = this.data.fkd.measure.settings;
      if(!!this.context.pmdexParams) { // override par params
        settings = this.model.widgetEngine.pmdExParams(this.context);
      }
      let strRes: string = this.model.workflowEngine.formatWorkflow(settings, rawValue);
          if(strRes) {
            let objRes: any = JSON.parse(strRes);
            if(!!objRes.image) {
              this.workImageBlob = objRes.image;
              this.workImage = AttachmentService.getInstance().downloadAttachmentForWidget(objRes.image, true);
            } else {
              this.workImage = of(null);
            }
            if(!!objRes.media) {
              this.workFile = objRes.media;
            } else {
              this.workFile = null;
            }
            this.workIcon = objRes.icon || null;
            this.workflowLabel = objRes.keys?.join(" ") || null;
          } else {
            this.workImageBlob = null;
            this.workImage = of(null);
            this.workFile = null;
            this.workIcon = null;
            this.workflowLabel = null;
          }
      this.useworkflow = true; 
    } else if (rendererKind === FIELD_KIND.BINARY) {
      if(!!rawValue) { // if(!!this.data.wcio.lbl) {
        let firstMed: string = rawValue.split(WizConstants.KEY_SEPARATOR)[0];
        this.imgSrcObs =  AttachmentService.getInstance().downloadAttachmentForWidget(firstMed);
        this.imgBlobid = firstMed;
      } else {
        this.imgSrcObs = of(null);
        this.imgBlobid = null;
      }
      this.useimgGp = true;
    } else if (rendererKind === FIELD_KIND.LIST) {
      this.uselistGP = true;
    } else if (rendererKind === FIELD_KIND.THRESHOLD) {
      this.uselistGP = true;
    } else {
      this.uselbl = true;
    }
  }

  private keyFormatter(fkd: FeiKeyDef, rawValue: string): void {
    let result: string = '';
    let finalDatakind: string = FIELD_KIND.STRING;
    // le champ à utiliser sur le FDV
    const fdvfield: string = this.wcio.fdvf || WizConstants.FIELD_LABEL;
    // le format
    const format: string = this.wcio.fmt;
    result = rawValue ||  '';
    if (!!result) {
      result = BaselineEngine.getLabel(this.fei, this.widgetLine, fkd.fullCode, fdvfield); // prendre la bonne valeur de champ FD
      
      finalDatakind = this.realKind(fkd, fdvfield); // possible override du type de rendu selon le champ sur un chrono
      result = this.model.formatEngine.applyFormat(result, finalDatakind, format, null); // et formater
    }
    this.formatedValue = result;
    this.realRenderer(finalDatakind, result);
  }

  private valueFormatter(fkd: FeiKeyDef, rawValue: string): void {
    // le format
    const format: string = this.wcio.fmt;
    this.formatedValue = this.model.formatEngine.applyFormat(rawValue, fkd.datakind, format, null);


    const fdvfield: string = this.wcio.fdvf || WizConstants.FIELD_LABEL;

    let finalDatakind = this.realKind(fkd, fdvfield); // possible override du type de rendu selon le champ sur un chrono
    
    // interception des measure.filter
    if(fkd.isMeasure && fkd.measure.dataKind === FIELD_KIND.FILTER) {
      try {
        let FDCode: string = (this.fkd.measure.settings as any).keys[0].FD;
        let FDVCode: string = rawValue;
        if(FDCode && FDVCode) {
          let renderField: string = (this.fkd.measure.settings as any).keys[0].render || ViewData.FIELD_LABEL;
          let fdv: FreedataValueVO = this.model.freedataEngine.getFreedataValue(FDCode, FDVCode);
          if(!!fdv) {
            rawValue = this.model.freedataEngine.getFDValue(fdv, renderField);
            this.formatedValue = rawValue;
          }
          //console.log('fdv', fdv, rawVal);
        }
      } catch (e:any) {
        //console.log("force DDExt on filter oups", e);     
      }
    } else if(fkd.isMeasure && fkd.measure.dataKind === FIELD_KIND.CROSS_FILTER) {
      try {
        console.log('TODO TODO crossFilter');
        let FDCode: string = (this.fkd.measure.settings as any).keys[0].FD;
        let FDVCode: string = rawValue;
        if(FDCode && FDVCode) {
          let renderField: string = (this.fkd.measure.settings as any).keys[0].render || ViewData.FIELD_LABEL;
          let fdv: FreedataValueVO = this.model.freedataEngine.getFreedataValue(FDCode, FDVCode);
          if(!!fdv) {
            rawValue = this.model.freedataEngine.getFDValue(fdv, renderField);
            this.formatedValue = rawValue;
          }
          //console.log('fdv', fdv, rawVal);
        }
      } catch (e:any) {
        //console.log("force DDExt on filter oups", e);     
      }
    } else if (fkd.measure?.dataKind === FIELD_KIND.LIST) {
      this.formatedValue = this.model.listFieldEngine.generateRenderer(this.widget.fei, this.data.fkd, [this.widgetLine], '<br>');
    } else if (fkd.measure?.dataKind === FIELD_KIND.THRESHOLD) {
      this.formatedValue = this.model.listFieldEngine.generateThresholdRenderer(this.widget.fei, this.data.fkd, [this.widgetLine], '<br>');
    }


    // définir quel champ utiliser
    let rendererKind: string = this.model.dataEngine.rendererKind(finalDatakind);
    this.realRenderer(rendererKind, rawValue);

  }

  /** fonction liée au bouton d'action */
  public doArgAction(): void {   
    // console.log('do Act', this.data);
    let cnxCode: string = null;
    if(!this.fkd) { // un fake
      cnxCode = this.data.wcio.lbl;
    } else { // une mesure action ou un rendu action de FD
      // console.log('connect', this.data);
      cnxCode = (this.data.widget as IForm).keyPartMap.get(this.fkd.fullCode); // les données sont calculées par le formWidget
    }

    if(!!cnxCode) {
      this.model.connectEngine.doArgActionExt(cnxCode, this.widget, [this.widgetLine]);
    } 
  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images

  /**
   * zoom sur une image
   */
  public seeImage(latency: number): void {  
    if(!!this.rawValue && latency > 400) {
        let params: zoomPopParams = {
          zoomPop: this.zoomPop,
          blobid: this.imgBlobid,
          // arg: this.data.arg,
          //fdvDS: this.data.ds
        }
        PopUtils.showZoomPop(params);
    }
  }
   /**
   * chargement de la pièce jointe du workflow
   */
  public loadDropWorkFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.workFile);
  } 
}
